<template>
    <div>
        <filters
            :disabled="disabled"
            :current-filter="getMediaSelectCurrentFilter"
            :default-filter="getMediaSelectDefaultFilter"
            :filter-dirty="getMediaSelectFilterDirty"
            :filter-count="getMediaSelectFilterCount"
            :filter-options="filterOptions"
            :set-filter="setFilter"
            :disable-groups="disableGroups"
            :text-search="textSearch"
            v-on:clear-filters="removeFilters"
            v-on:apply-filters="applyFilters"
            v-on:text-search="textSearch = $event"
        />
    </div>
</template>

<script>
import { find, isEqual } from 'lodash';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import Filters from './Filters';

// mixins
import common from './mixins/common';

export default {
    name: 'MediaSelectFilters',
    mixins: [common],
    components: {
        Filters,
    },
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        filterOptions: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            textSearch: null,
        };
    },
    computed: {
        ...mapGetters([
            'getMediaSelectCurrentFilter',
            'getMediaSelectDefaultFilter',
            'getMediaSelectFilterDirty',
            'getMediaSelectFilterCount',
        ]),
    },
    watch: {
        textSearch: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.setMediaSelectFilter({
                        mode: 'single',
                        filter: {
                            text: newValue,
                        },
                    });
                } else {
                    this.removeMediaSelectFilter({value: {text: oldValue}});
                }
            },
        },
    },
    methods: {
        ...mapActions([
            'removeMediaSelectFilter',
            'resetMediaSelectFilters',
        ]),
        ...mapMutations([
            'setMediaSelectFilter',
            'setMediaSelectCurrentFilter',
            'setMediaSelectFilterApplied',
        ]),
        removeFilters(e) {
            this.textSearch = '';
            this.resetMediaSelectFilters().then(() => {
                this.$emit('filters-set');
            });
        },
        setFilter(e, filter, group) {
            const filterKey = Object.keys(filter.value)[0];

            for (let item of this.filterOptions) {

                if (item.allow && !item.allow.includes(Object.keys(filter.value)[0])) {

                    for (let groupFilter of group.filters) {

                        if (group.allow && groupFilter.value && !group.allow.includes(Object.keys(groupFilter.value)[0])) {
                            if (filter.mode === 'single' && !isEqual(filter, groupFilter)) {
                                this.removeMediaSelectFilter(groupFilter);
                            }

                            if ((filter.mode === 'multiple' && groupFilter.mode === 'single') || (filter.mode === 'single' && groupFilter.mode === 'multiple')) {
                                this.removeMediaSelectFilter(groupFilter);
                            }

                            if (filter.deny && filter.deny.length > 0) {
                                filter.deny.forEach((denied)  => {
                                    this.getMediaSelectCurrentFilter.some((item) => {
                                        if (isEqual(denied, item)) {
                                            this.removeMediaSelectFilter(denied);
                                        }
                                    });
                                });
                            }
                        }
                    }
                }
            }
            this.disableGroups();
            this.setMediaSelectFilter({filter: filter.value, checked: e.target.checked, mode: filter.mode});
        },
        applyFilters() {
            this.$emit('filters-set');
            this.setMediaSelectFilterApplied(true);
        },
    }
}
</script>
